import { render, staticRenderFns } from "./ScenarioSlide.vue?vue&type=template&id=69b0a368"
import script from "./ScenarioSlide.vue?vue&type=script&lang=js"
export * from "./ScenarioSlide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69b0a368')) {
      api.createRecord('69b0a368', component.options)
    } else {
      api.reload('69b0a368', component.options)
    }
    module.hot.accept("./ScenarioSlide.vue?vue&type=template&id=69b0a368", function () {
      api.rerender('69b0a368', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/teacher/vue/slides/ScenarioSlide.vue"
export default component.exports